import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Paper, Alert, CircularProgress } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { loginRequest } from "../auth/msalConfig";
import { getInstance } from '../auth/msalInstance';
import type { PublicClientApplication } from "@azure/msal-browser";

export const LoginPage: React.FC = () => {
    const [error, setError] = useState<string | null>(null);
    const [msalInstance, setMsalInstance] = useState<PublicClientApplication | null>(null);

    useEffect(() => {
        getInstance().then(instance => {
            setMsalInstance(instance);
        });
    }, []);

    const handleLogin = async () => {
        if (!msalInstance) return;
        
        try {
            setError(null);
            const response = await msalInstance.loginPopup(loginRequest);
            if (response.account) {
                msalInstance.setActiveAccount(response.account);
            }
        } catch (e) {
            console.error('Login error:', e);
            setError(e instanceof Error ? e.message : 'An error occurred during login');
        }
    };

    if (!msalInstance) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            bgcolor={(theme) => theme.palette.background.default}
        >
            <Paper 
                elevation={3}
                sx={{
                    p: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 3,
                    maxWidth: 400,
                    width: '100%'
                }}
            >
                <Typography variant="h4" component="h1" gutterBottom>
                    Dwaynes Assistance Devices
                </Typography>
                <Typography variant="body1" color="textSecondary" align="center">
                    Please sign in with your Azure AD account to access the device management dashboard.
                </Typography>
                {error && (
                    <Alert severity="error" sx={{ width: '100%' }}>
                        {error}
                    </Alert>
                )}
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<LoginIcon />}
                    onClick={handleLogin}
                >
                    Sign in with Azure AD
                </Button>
            </Paper>
        </Box>
    );
}; 